var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lithuania-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 17.999,
    cy: 17.999,
    r: 17.999,
    transform: "translate(0.002 0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5280",
    "data-name": "Path 5280",
    d: "M34.971,12H23.881A49.771,49.771,0,0,1,23.89,23.93h11.1A18.014,18.014,0,0,0,34.971,12Z",
    fill: "#016b44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5281",
    "data-name": "Path 5281",
    d: "M23.881,12h11.09l-.006-.016A18.011,18.011,0,0,0,19.616.074C22.371,1.584,23.176,6.369,23.881,12Z",
    fill: "#fcb817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5282",
    "data-name": "Path 5282",
    d: "M19.616,35.926A18.012,18.012,0,0,0,34.978,23.982c.006-.017.011-.034.017-.051H23.89C23.191,29.59,22.383,34.409,19.616,35.926Z",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5283",
    "data-name": "Path 5283",
    d: "M0,18a17.969,17.969,0,0,0,1,5.93H24.817A49.771,49.771,0,0,0,24.808,12H1.029A17.962,17.962,0,0,0,0,18Z",
    fill: "#03754a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5284",
    "data-name": "Path 5284",
    d: "M1.034,11.983,1.028,12H24.808C24.1,6.369,22.371,1.585,19.616.074,19.084.027,18.545,0,18,0A18,18,0,0,0,1.034,11.983Z",
    fill: "#fcb933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5285",
    "data-name": "Path 5285",
    d: "M24.817,23.93H1l.017.051A18,18,0,0,0,18,36c.545,0,1.084-.027,1.617-.074C22.383,34.409,24.118,29.59,24.817,23.93Z",
    fill: "#c8333d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLt);
export default __webpack_public_path__ + "static/media/ico_lt.22766a1466ed60a5749b15f1825eb44c.svg";
export { ForwardRef as ReactComponent };